import { toast } from '@approvalmax/ui/src/components';
import { browserHelpers } from '@approvalmax/utils';
import { useEffect } from 'react';
import { isWrongEmailSso, removeWrongEmailSso } from 'shared/helpers';

import { useProfileSetup } from '../../hooks/useProfileSetup/useProfileSetup';
import { messages } from './ProfileStepContainer.messages';
import { ProfileStepContainerProps } from './ProfileStepContainer.types';

export const useProfileStepContainer = (props: ProfileStepContainerProps) => {
    const { profileData, invitations, onGoToNextStep, onSetQualificationQuestionsAnswers } = props;

    const hasInvitations = invitations.length > 0;

    const { isLoading, mutate: submit } = useProfileSetup({
        profileData,
        onGoToNextStep,
        onSetQualificationQuestionsAnswers,
        disableNotifications: browserHelpers.isMobile(),
    });

    useEffect(() => {
        if (isWrongEmailSso()) {
            toast.error(messages.wrongEmailSso);
            removeWrongEmailSso();
        }
    }, []);

    return {
        isLoading,
        hasInvitations,
        handleProfileFormSubmit: submit,
    };
};
